<template>
  <div class="class">
    <a class="apply">个人信息</a>
    <div class="inapply">
      <div class="content">
        <span>用户名：</span>
        <span>{{userInfo.name}}</span>
      </div>
      <div class="content">
        <span>身份证号：</span>
        <span>{{userInfo.idcard}}</span>
      </div>
      <div class="content">
        <span>组织：</span>
        <span>{{userInfo.orgName}}</span>
      </div>
      <div class="content" v-for="(item,index) in items" :key="index">
        <span>{{item.lablename}}：</span>
        <span v-if="isSelected(item.optionType)">{{selectText(item)}}</span>
        <span v-else>{{userInfo[item.regname]}}</span>
      </div>
      <el-button type="primary" @click="amend">修改资料</el-button>
    </div>
    <div class="a" v-if="dialogTableVisible">
      <el-dialog
        title="修改资料"
        :visible.sync="dialogTableVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="40%"
      >
        <Amend @close="dialogTableVisible = false"></Amend>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import Amend from "../Amend";
  export default {
    name: "information",
    data() {
      return {
        dialogTableVisible: false,
        registrations: this.$getRegistrationItem()
      };
    },
    computed: {
      userInfo() {
        return this.$store.state.user || {};
      },
      items() {
        return this.registrations.registrationItem;
      },
    },
    created() {
    },
    methods: {
      // 修改资料
      amend() {
        this.dialogTableVisible = true;
      },
      isSelected(optionType) {
        return optionType == 'radio' || optionType == 'select';
      },
      selectText(item) {
        for (let k in item.optionData) {
          if (this.userInfo[item.regname] == item.optionData[k].value) {
            return item.optionData[k].text;
          }
        }
        return '';
      },
    },
    components: {
      Amend
    }
  }
</script>
<style scoped>
  @import "../../assets/css/iconfont.css";
  @import "../../assets/css/common.css";
  @import "../../assets/css/index.css";
  @import "../../assets/css/cms.css";

  .inapply {
    width: 70%;
    position: absolute;
    left: 300px;
    top: 100px;
    display: flex;
    flex-flow: column;
  }
  .content {
    width: 100%;
    height: 30px;
    position: relative;
    margin-bottom: 10px;
  }
  .content span {
    text-align: left;
  }
  .content span:nth-child(1) {
    width: 200px;
    height: 30px;
    display: inline-block;
    position: absolute;
    left: 0;
    text-align: right;
    line-height: 30px;
  }
  .content span:nth-child(2) {
    width: 80%;
    height: 30px;
    display: inline-block;
    position: absolute;
    left: 200px;
    line-height: 30px;
    text-align: left;
  }

  .el-button {
    width: 100px;
    height: 30px;
    position: relative;
    right: -180px;
    top: -50px;
  }
  .el-button {
    position: absolute;
    left: 200px;
    top: 400px;
  }
  .el-dialog {
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mySpace/information.vue